import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import notifications from './modules/notifications'
import users from './modules/users/users'
import notes from './modules/users/notes'
import utils from './modules/utils'
import tags from './modules/tags'
import courses from './modules/courses/courses'
import content from './modules/content/content'
import section from './modules/content/section'
import tasks from './modules/content/tasks'
import questions from './modules/questions'
import payments from './modules/payments'
import progress from './modules/student/progress'
import contentProgress from './modules/student/contentProgress'
import sectionProgress from './modules/student/sectionProgress'
import taskProgress from './modules/student/taskProgress'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    notifications,
    users,
    notes,
    utils,
    tags,
    courses,
    content,
    section,
    tasks,
    questions,
    payments,
    progress,
    contentProgress,
    sectionProgress,
    taskProgress
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js